import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import SennderHeader from "../components/SennderHeader";
import Sidebar from "../components/Sidebar";
import { Layout } from "antd";
import FirstAccessModal from "../components/modals/FirstAccessModal";
import PenaltiesPositioningInfoModal from "../components/modals/alerts/PenaltiesPositioningInfoModal";
import GpsPenaltyInfoModal from "../components/modals/alerts/GpsPenaltyInfoModal";

const { Content, Sider } = Layout;

interface IProps {
  children?: React.ReactNode;
}

const AppLayout: React.FC<IProps> = ({ children }) => {
  const [showAccessModal, setShowAccessModal] = useState(false);
  const [, setShowPositioningModal] = useState(false);
  const [showGpsModal, setShowGpsModal] = useState(false);

  useEffect(() => {
    const firstAccess = localStorage.getItem("showFirstAccess");
    const firstPositioning = localStorage.getItem("showPositioningModal");
    const firstGps = localStorage.getItem("showGpsPenaltyModal");
    if (firstAccess == null || firstAccess === "true") setShowAccessModal(true);
    if (firstPositioning == null || firstPositioning === "true")
      setShowPositioningModal(true);
    if (firstGps == null || firstGps === "true") setShowGpsModal(true);
  }, []);

  const handleModalOk = (noShow: boolean) => {
    setShowAccessModal(false);
    if (noShow) localStorage.setItem("showFirstAccess", "false");
    else localStorage.setItem("showFirstAccess", "true");
  };

  const handlePositioningModalOk = (noShow: boolean) => {
    setShowPositioningModal(false);
    if (noShow) localStorage.setItem("showPositioningModal", "false");
    else localStorage.setItem("showPositioningModal", "true");
  };

  const handleGpsModalOk = (noShow: boolean) => {
    setShowGpsModal(false);
    if (noShow) localStorage.setItem("showGpsPenaltyModal", "false");
    else localStorage.setItem("showGpsPenaltyModal", "true");
  };

  return (
    <Layout style={{ backgroundColor: "#fafafa" }} className="layout">
      <SennderHeader />
      <FirstAccessModal onOk={handleModalOk} open={showAccessModal} />

      <PenaltiesPositioningInfoModal
        onOk={handlePositioningModalOk}
        open={false}
      />

      <GpsPenaltyInfoModal
        onOk={handleGpsModalOk}
        open={showGpsModal && !showAccessModal}
      />

      <Content>
        <Layout
          style={{
            padding: "5px 0",
            backgroundColor: "#fafafa",
            height: "100%",
          }}
        >
          <Sider
            width={200}
            style={{ backgroundColor: "#fafafa", height: "100vh" }}
          >
            <Sidebar />
          </Sider>

          <Content style={{ minHeight: 280 }}>{children}</Content>
        </Layout>
      </Content>

      <Outlet />
    </Layout>
  );
};

export default AppLayout;
